module.exports = __webpack_public_path__ + "img/weibo1.ad2e3c3f.jpg";